import { render, staticRenderFns } from "./unqualifiedDestructionHistory.vue?vue&type=template&id=8490b272&scoped=true"
import script from "./unqualifiedDestructionHistory.vue?vue&type=script&lang=js"
export * from "./unqualifiedDestructionHistory.vue?vue&type=script&lang=js"
import style0 from "./unqualifiedDestructionHistory.vue?vue&type=style&index=0&id=8490b272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8490b272",
  null
  
)

export default component.exports